import { useQuery } from "@tanstack/react-query";
import { API } from "config";
import moment from 'moment';

const useOptions = () => {
    return useQuery({
        queryKey: ['options'],
        queryFn: async () => {
            const { data } = await API.get('/all-options');
            const today = parseInt(moment().format('D'));

            // Limite individual de Terceiros (third_party_limit + third_party_percentage)
            const isThirdPartyLimitEnabled = data?.third_party_limit == "1" || data?.third_party_limit == 1;
            const thirdPartyPercentage = parseFloat(data?.third_party_percentage || 50);

            // Limites de Bônus+Terceiros combinados (bonus_third_party_*)
            // Complementam o limite individual acima. Valor 0 = regra desativada.
            const bonusThirdMaxOrderValue = parseInt(data?.bonus_third_party_max_order_value || 0);
            const bonusThirdMaxPercentage = parseInt(data?.bonus_third_party_max_percentage || 0);
            const bonusThirdMaxFixedValue = parseInt(data?.bonus_third_party_max_fixed_value || 0);

            // Regra dos dias de Saque: aqui a gente mantém o 'includes'
            // porque o saque só rola nos dias exatos marcados no banco.
            let withdrawData = { isAvailable: false, rawDays: "" };
            if (data?.withdrawal_days) {
                try {
                    const days = JSON.parse(data.withdrawal_days).map(Number);
                    withdrawData = {
                        isAvailable: days.includes(today),
                        rawDays: days.join(', ')
                    };
                } catch (e) {
                    console.error("Erro ao processar withdrawal_days", e);
                }
            }

            // Obtém limite mínimo de saque;
            let limitRatedWithdrawalMin = {rawLimitRatedWithdrawalMin: ""};
            if (data.withdrawal_min) {
                try {
                    limitRatedWithdrawalMin = {
                        rawLimitRatedWithdrawalMin: data.withdrawal_min
                    }

                } catch (e) {

                }
            }

            // Regra da Nota Fiscal: aqui a lógica muda. O consultor pode anexar
            // a nota ATÉ o último dia definido no array 'note_attachment_limit'.
            let noteData = { isNoteAvailable: false, rawNoteDays: "" };
            if (data?.note_attachment_limit) {
                try {
                    const days = JSON.parse(data.note_attachment_limit).map(Number);

                    // Pego o maior dia do array pra servir de data limite (ex: se for [15], o limite é 15)
                    const limitDay = days.length > 0 ? Math.max(...days) : null;

                    if (limitDay) {
                        noteData = {
                            // Se hoje for 13 e o limite 15, ainda tá valendo.
                            isNoteAvailable: today <= limitDay,
                            // Garanto que o dia apareça na string pro alerta não ficar vazio.
                            rawNoteDays: limitDay.toString()
                        };
                    }
                } catch (e) {
                    console.error("Erro ao processar note_attachment_limit", e);
                    // Fallback para não quebrar a UI
                    noteData = { isNoteAvailable: false, rawNoteDays: "--" };
                }
            }

            return {
                ...withdrawData, // Dados de saque (isAvailable, rawDays)
                ...noteData,     // Dados de nota (isNoteAvailable, rawNoteDays)
                ...limitRatedWithdrawalMin, // Dados Limite mínimo de saque
                isThirdPartyLimitEnabled: !!isThirdPartyLimitEnabled,
                thirdPartyPercentage,
                bonusThirdMaxOrderValue,
                bonusThirdMaxPercentage,
                bonusThirdMaxFixedValue,
            };
        },
        staleTime: 0,
        gcTime: 0,
        refetchOnWindowFocus: true,
        refetchOnMount: true,
    });
};

export default useOptions;